export default "__VITE_ASSET__DJ6bir0$__"